var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"60vh"}},[_c('v-icon',{staticClass:"fa-spin",attrs:{"size":"50px"}},[_vm._v("fa-spinner")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }